import React, { ReactNode } from "react";
import styled, { css } from "styled-components";
import { Icon, iconName } from "./icons/Icons";
import { buttonStyling } from "./button/Shared";
import { Flex } from "./compositeComponents/FlexHelpers";
import { colors } from "./colors/color";


export function ChipPanel(props:{children:ReactNode})
{
    return (
        <Flex gap={4} style={{ flexWrap: 'wrap' }}>
            {props.children}
        </Flex>
    )
}

type ChipProps = {
    selected?:boolean,
    onClick?:()=>void,
    button?:{ icon:iconName, onClick?:()=>void },
    colorOverride?:{
        content:string,
        background:string
    }
    children:ReactNode,
};

export function Chip(props:ChipProps): JSX.Element
{
    function handleKeyDown(e:React.KeyboardEvent<HTMLDivElement>)
    {
        if(props.button && (e.key === 'Enter' || e.key === ' '))
            props.button.onClick?.();
    }

    function handleButtonClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>)
    {
        if(props.button)
            props.button.onClick?.();

        e.stopPropagation();
    }

    return (
        <PillContainer 
            selected={props.selected || false}
            role={props.onClick ? 'button' : undefined}
            tabIndex={props.onClick ? 0 : undefined}
            canHover={props.onClick !== undefined}
            onClick={() => props.onClick && props.onClick()}
            onKeyDown={handleKeyDown}
            contentColor={props.colorOverride ? props.colorOverride.content : undefined}
            backgroundColor={props.colorOverride ? props.colorOverride.background : undefined}>
            
            <div style={{display:'flex', justifyContent:'center', padding:`0px ${props.button ? '0px' : '8px'} 0px 8px`}}>
                {props.children}
            </div>

            {props.button &&
                <button onClick={handleButtonClick}>
                    <Icon sizeOverride={18} name={props.button.icon} />
                </button>
            }
            
        </PillContainer>
    );
}

const PillContainer = styled.div<{canHover:boolean, selected:boolean, contentColor?:string, backgroundColor?:string}>`
    display:inline-flex;
    min-width: 40px;
    justify-content: center;
    align-items: center;
    padding: 2px;
    border-radius: 14px;
       
    font-family: "Noto Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;


    cursor:${props => props.canHover ? 'pointer' : 'default'};

    background: ${props => props.backgroundColor || (props.selected ? colors.pill.backgroundSelected : colors.pill.background)};

    color: ${props => props.contentColor || buttonStyling(props.theme.colors).handleButtonColor(props.selected ? 'light' : 'outlined')};

    border: ${props => `1px solid ${props.selected ? colors.pill.backgroundSelected : colors.pill.border}`};

    & button {
        background: transparent;
        border:none;
        & svg{
            fill:${props => props.selected ? '#555' : '#555'};
        }
        &:hover{
            cursor:pointer;
            color: ${props => buttonStyling(props.theme.colors).handleButtonHoverColor(props.selected ? 'light' : 'outlined')};
            & svg{
                fill:${props => props.selected ? '#aaa' : '#aaa'};
            }
        }
    }

    ${props => {
        if(props.canHover){
            return css`    
                &:hover {
                    transition: all 0.5s ease;
                    background: ${buttonStyling(props.theme.colors).handleButtonHoverBackground(props.selected ? 'light' : 'outlined')};
                    color: ${buttonStyling(props.theme.colors).handleButtonHoverColor(props.selected ? 'light' : 'outlined')};
                    & svg{
                        fill: ${buttonStyling(props.theme.colors).handleButtonHoverColor(props.selected ? 'light' : 'outlined')};
                    }
                }`;
        }
    }};
`;